import { render, staticRenderFns } from "./IssueReasonModal.vue?vue&type=template&id=470f0c5c&scoped=true"
import script from "./IssueReasonModal.vue?vue&type=script&lang=js"
export * from "./IssueReasonModal.vue?vue&type=script&lang=js"
import style0 from "./IssueReasonModal.vue?vue&type=style&index=0&id=470f0c5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470f0c5c",
  null
  
)

export default component.exports